export class SendActPayReceiptForm {
    actNumber:string;
    comments:string='';

    constructor(other ?:SendActPayReceiptForm) {
        if (other) {
            this.actNumber = other.actNumber;
            this.comments = other.comments;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/sendActPayReceiptForm.ts
 **/